import { useState, useEffect } from 'react';
import { BLUE, BG, DARK } from '../constants/colors';
import AORLogo from './AORLogo';

const MSGS = [
  'Analyzing your business profile...',
  'Applying {state} market factors...',
  'Comparing rates across 27 carriers...',
  'Calculating coverage gaps...',
  'Modeling 5-year savings projection...',
  'Building your report...',
];

const TOTAL_MS = 2400;
const MSG_MS = Math.floor(TOTAL_MS / MSGS.length); // 400ms per message
const FADE_MS = 80;

export default function LoadingScreen({ stateName }) {
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (idx >= MSGS.length - 1) return;
    const fadeOut = setTimeout(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx(i => i + 1);
        setVisible(true);
      }, FADE_MS);
    }, MSG_MS - FADE_MS);
    return () => clearTimeout(fadeOut);
  }, [idx]);

  const msg = MSGS[idx].replace('{state}', stateName || 'your state');
  const progress = Math.round(((idx + 1) / MSGS.length) * 100);

  return (
    <div style={{minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',background:BG,gap:24,padding:'0 20px'}}>
      <AORLogo height={52}/>
      <div style={{width:'100%',maxWidth:360,display:'flex',flexDirection:'column',alignItems:'center',gap:20}}>
        {/* Progress bar */}
        <div style={{width:'100%',height:6,background:'#E2E8F0',borderRadius:99,overflow:'hidden'}}>
          <div style={{
            height:'100%',
            width:`${progress}%`,
            background:`linear-gradient(90deg,${BLUE},#1a6fa0)`,
            borderRadius:99,
            transition:`width ${MSG_MS}ms cubic-bezier(.4,0,.2,1)`,
          }}/>
        </div>
        {/* Animated message */}
        <div style={{height:48,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <p style={{
            color:DARK,
            fontSize:15,
            fontWeight:600,
            fontFamily:'sans-serif',
            margin:0,
            textAlign:'center',
            opacity: visible ? 1 : 0,
            transition:`opacity ${FADE_MS}ms ease`,
          }}>
            {msg}
          </p>
        </div>
        {/* Step dots */}
        <div style={{display:'flex',gap:8}}>
          {MSGS.map((_,i)=>(
            <div key={i} style={{
              width: i===idx ? 20 : 7,
              height:7,
              borderRadius:99,
              background: i<=idx ? BLUE : '#E2E8F0',
              transition:'all 0.35s ease',
            }}/>
          ))}
        </div>
      </div>
    </div>
  );
}
